import { isEmpty, uniqueId } from 'lodash'
import { automatedPanelStore } from 'services/state'

export const saveAutomatedPanelInfo = (
  type,
  request = {},
  simulatedNotification = {}
) => {
  const id = uniqueId()
  const sendTime = new Date().getTime()

  automatedPanelStore.update((prev) => ({
    ...prev,
    simulatedNotification: !isEmpty(simulatedNotification) && {
      id,
      ...simulatedNotification
    },
    notifications: [
      ...prev.notifications,
      { id, type, startTime: sendTime, requestFe: request }
    ]
  }))
}
